import MaterialDetails from './MaterialDetails';

export default MaterialDetails;
